import { IRoute } from "./types"
import { lazy } from "react"

const HomePage = lazy(() =>
	import("@/pages/HomePage").then(module => ({ default: module.HomePage }))
)
const SingleProductPage = lazy(() =>
	import("@/pages/SingleProductPage").then(module => ({ default: module.SingleProductPage }))
)

const PrivacyPolicyPage = lazy(() =>
	import("@/pages/PrivacyPolicyPage").then(module => ({ default: module.PrivacyPolicyPage }))
)

class RouterConfig {
	routes: IRoute[] = [
		{
			path: "/",
			component: <HomePage />,
			slug: "home",
		},
		{
			path: "/feed",
			component: <HomePage />,
			slug: "feed",
		},
		{
			path: "/product/:id",
			component: <SingleProductPage />,
			slug: "singleProduct",
		},
		{
			path: "/privacy",
			component: <PrivacyPolicyPage />,
			slug: "privacyPolicy",
		},
	]

	getRouteBySlug(slug: string) {
		return this.routes.find(route => route.slug === slug)
	}
}

export const routerConfig = new RouterConfig()
